// extracted by mini-css-extract-plugin
export var deleteIcon = "_tw-5";
export var deleteOption = "_tw-3";
export var divider = "_tw-2";
export var downloadIcon = "_tw-4";
export var drawer = "_tw-0";
export var drawerFooter = "_tw-6";
export var drawerOpen = "_tw-1";
export var highlighted = "_tw-7";
export var lighterHighlight = "_tw-8";